const maps = [
  [
    '                          ',
    '                          ',
    '                          ',
    '                          ',
    '                     ^    ',
    '      ^                  *',
    '          ^               ',
    '  ^                       ',
    '                          ',
    '                          ',
    '                          ',
    '                          ',
    '=====    =====  ====   ==='
  ], [
    '                           ',
    '                           ',
    '                  ^        ',
    '          ^         ==     ',
    '          ==    ^          ',
    '   ^  ^                    ',
    '          ^              * ',
    '  ^  ==          ^         ',
    '                           ',
    '                       ==  ',
    '                           ',
    '                           ',
    '======   =  ===  ==  ====  '
  ], [
    '                           ',
    '                           ',
    '            ^              ',
    '                           ',
    '          ==      ^     *  ',
    '   ^  ^                    ',
    '                ^          ',
    '  ^  ==             ^      ',
    '            ==             ',
    '                           ',
    '                           ',
    '                        ^  ',
    '===  ===   ===  === ===   ='
  ],
]

export default maps